export default "__VITE_ASSET__213f771a__"